import React, { FC } from 'react';
import { InsertPageBreak } from '@mui/icons-material';
import { MenuButton, useRichTextEditorContext } from 'mui-tiptap';

export const PageBreakToolbarButton: FC = () => {
  const editor = useRichTextEditorContext();

  const handleOnClick = () => {
    editor?.chain().focus().insertPageBreak().run();
  };

  if (!editor) return null;

  const canInsert = editor.can().insertPageBreak();

  return (
    <MenuButton
      disabled={!editor?.isEditable || !canInsert}
      IconComponent={InsertPageBreak}
      tooltipLabel="Sideskift"
      onClick={handleOnClick}
    />
  );
};
